var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatchPredictionRounded48Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "batch-prediction-rounded-48dp",
    transform: "translate(0 -0.193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17356",
    "data-name": "Ret\\xE2ngulo 17356",
    width: 16,
    height: 16,
    transform: "translate(0 0.193)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7293",
    "data-name": "Caminho 7293",
    d: "M16.767,7.421H9.739A1.389,1.389,0,0,0,8.333,8.784V15.6a1.389,1.389,0,0,0,1.406,1.363h7.028A1.389,1.389,0,0,0,18.172,15.6V8.784A1.389,1.389,0,0,0,16.767,7.421Zm-3.514,8.517h0a.694.694,0,0,1-.7-.681v-.341h1.406v.341A.694.694,0,0,1,13.253,15.939Zm.7-1.7H12.55c0-1.022-1.757-2.044-1.757-3.407a2.461,2.461,0,0,1,4.92,0C15.713,12.191,13.956,13.213,13.956,14.235ZM17.47,6.4H9.036A1.037,1.037,0,0,1,10.09,5.377h6.325A1.037,1.037,0,0,1,17.47,6.4Zm-.7-2.044H9.739a1.037,1.037,0,0,1,1.054-1.022h4.92a1.037,1.037,0,0,1,1.054,1.022Z",
    transform: "translate(-5.177 -2.03)",
    fill: "#6d6d6d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchPredictionRounded48Dp);
export default __webpack_public_path__ + "static/media/batch-prediction-rounded-48dp.8ebe7f951edbbca64155f7397c8b76df.svg";
export { ForwardRef as ReactComponent };